/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./header-title.vue?vue&type=template&id=24b4ea5b&"
import script from "./header-title.vue?vue&type=script&lang=ts&"
export * from "./header-title.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports